// Blurhash → tiny BMP data URL. No canvas, so it also runs during SSG and the
// placeholder is in the static HTML before any JS loads.
import { decode, isBlurhashValid } from 'blurhash';

export function blurhashDataUrl(hash: string | null | undefined, width = 32, height = 18): string | null {
  if (!hash || !isBlurhashValid(hash).result) return null;
  const pixels = decode(hash, width, height);

  const rowSize = Math.ceil((width * 3) / 4) * 4;
  const dataSize = rowSize * height;
  const bytes = new Uint8Array(54 + dataSize);
  const view = new DataView(bytes.buffer);
  bytes[0] = 0x42;
  bytes[1] = 0x4d;
  view.setUint32(2, bytes.length, true);
  view.setUint32(10, 54, true);
  view.setUint32(14, 40, true);
  view.setInt32(18, width, true);
  view.setInt32(22, height, true);
  view.setUint16(26, 1, true);
  view.setUint16(28, 24, true);
  view.setUint32(34, dataSize, true);

  // BMP rows are bottom-up, BGR.
  for (let y = 0; y < height; y++) {
    const row = 54 + (height - 1 - y) * rowSize;
    for (let x = 0; x < width; x++) {
      const src = (y * width + x) * 4;
      const dst = row + x * 3;
      bytes[dst] = pixels[src + 2];
      bytes[dst + 1] = pixels[src + 1];
      bytes[dst + 2] = pixels[src];
    }
  }

  let bin = '';
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return `data:image/bmp;base64,${btoa(bin)}`;
}
